import script from "./PhotoTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoTemplate.vue?vue&type=style&index=0&id=0fce2f98&lang=css"

const __exports__ = script;

export default __exports__